import { Box } from '@nick-mazuk/ui/elements/box'
import type { Colors } from '@nick-mazuk/ui/elements/button'
import { Text } from '@nick-mazuk/ui/elements/text'
import { ScriptItem } from 'components/script-item'

import type { Script } from 'lib/sanity'

type Properties = {
    scripts: Script[]
    color?: Colors
}

export const Scripts = ({ scripts, color = 'primary' }: Properties): JSX.Element => {
    return (
        <section id='scripts' className='mt-12 wrapper'>
            <div className='gap-8 lg:grid' style={{ gridTemplateColumns: 'minmax(0, 1fr) 384px' }}>
                <div className='grid grid-flow-row gap-16'>
                    {scripts.map((script) => (
                        <ScriptItem script={script} color={color} key={script.title} />
                    ))}
                </div>
                <div className='hidden lg:block'>
                    <nav className='sticky top-24'>
                        <Box style='outline'>
                            <Text bold>Scripts</Text>
                            {scripts.map((script) => (
                                <Text key={script.title}>
                                    <a href={`#${script.title}`} className='hover:text-primary'>
                                        {script.title}
                                    </a>
                                </Text>
                            ))}
                        </Box>
                    </nav>
                </div>
            </div>
        </section>
    )
}

export type Scripts = ReturnType<typeof Scripts>
